import { lazy } from 'react';

// project imports
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

// public (unauthenticated) business-facing onboarding — the token in the URL is the authorization.
// These routes deliberately sit OUTSIDE GuestGuard so no session-based redirect (e.g. a logged-in
// CMS browser being bounced to /dashboard) can ever fire — the page must render for every visitor.
const OnboardingForm = Loadable(lazy(() => import('views/onboarding/OnboardingForm')));
const OnboardingChecklist = Loadable(lazy(() => import('views/onboarding/OnboardingChecklist')));

// ==============================|| PUBLIC ROUTING ||============================== //

const PublicRoutes = {
    path: '/',
    // MinimalLayout renders only <Outlet/> — no auth, no session redirect
    element: (
        <NavMotion>
            <MinimalLayout />
        </NavMotion>
    ),
    children: [
        {
            path: '/onboarding/form/:token',
            element: <OnboardingForm />
        },
        {
            path: '/onboarding/checklist/:token',
            element: <OnboardingChecklist />
        }
    ]
};

export default PublicRoutes;
